import React from 'react';

const NormSearchIcon = ({ className = "h-5 w-5 text-white" }) => (
  <svg className={className} viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" stroke="currentColor" strokeLinecap="square">
      <path d="M16 16l-5.0752-5.0752" />
      <circle cx="6.4" cy="6.4" r="6.4" />
    </g>
  </svg>
);

export default NormSearchIcon;
